import type { FC } from 'react';
import { CompactBreakdownContainer } from '../../../BaseDealActivity.interstate.style';
import BreakdownTabs from './BreakdownTabs.interstate';

interface BreakdownTabsContainerProps {
    scopeId?: string;
    isFullWidth: boolean;
}
const BreakdownTabsContainer: FC<BreakdownTabsContainerProps> = ({ scopeId, isFullWidth }) => (
    <CompactBreakdownContainer className={isFullWidth ? 'full-width-breakdown-container' : 'breakdown-container'} xs={5}>
        <BreakdownTabs scopeId={scopeId} />
    </CompactBreakdownContainer>
);

export default BreakdownTabsContainer;
